// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__ufrCm","BrandsSearch":"SearchBar_BrandsSearch__FhDGo","BrandsByStartingName":"SearchBar_BrandsByStartingName__gom87"};